module.exports = __webpack_public_path__ + "static/media/error-circle.6c803158.svg";